module.exports = __webpack_public_path__ + "img/logo-grayscale.a558bac5.svg";